import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatTravelStatus',
  standalone: true,
})
export class FormatTravelStatusPipe implements PipeTransform {
  transform(status: string): string {
    if (status.toLowerCase() === 'cancelled') {
      return 'Cancelado';
    } else if (status.toLowerCase() === 'collected') {
      return 'En recogida';
    } else if (status.toLowerCase() === 'executed') {
      return 'En ejecución';
    } else if (status.toLowerCase() === 'finalized') {
      return 'Finalizado';
    } else if (status.toLowerCase() === 'requested') {
      return 'En solicitud';
    }

    return 'Desconocido';
  }
}
